
import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';


export const DashboardTypes = {
    SAVED_SEARCH: 'savedSearch',
    TOPIC: 'topic',
    INSTANT_SEARCH: 'instantSearch'
};

export function useGetDashboardType() {
    const listeningQueryId = useCurationConfigValue('listeningQueryId');
    const topicId = useCurationConfigValue('topicId');
    const searchTerms = useCurationConfigValue('searchTerms');

    if (listeningQueryId && !topicId) {
        return DashboardTypes.SAVED_SEARCH;
    }

    if (topicId) {
        return DashboardTypes.TOPIC;
    }

    if (!_.isEmpty(searchTerms)) {
        return DashboardTypes.INSTANT_SEARCH;
    }
}
